

const data = [
    {
        id: 1,
        title: "Free",
        price: "0$",
        users: "Single User",
        storage: "5 GB Storage",
        public_projects: "Unlimited Public Projects",
        access: "Community Access",
        private_projects: "Unlimited Private Projects",
        phone_support: "Dedicated Phone Support",
        subdomain: "Free Subdomain",
        status_report: "Monthly Status Report",
      },
      {
        id: 2,
        title: "Plus",
        price: "9$",
        users: "5 Users",
        storage: "50 GB Storage",
        public_projects: "Unlimited Public Projects",
        access: "Community Access",
        private_projects: "Unlimited Private Projects",
        phone_support: "Dedicated Phone Support",
        subdomain: "Free Subdomain",
        status_report: "Monthly Status Report",
      },
      {
        id: 3,
        title: "Pro",
        price: "49$",
        users: "Unlimited User",
        storage: "150 GB Storage",
        public_projects: "Unlimited Public Projects",
        access: "Community Access",
        private_projects: "Unlimited Private Projects",
        phone_support: "Dedicated Phone Support",
        subdomain: "Free Subdomain",
        status_report: "Monthly Status Report",
      }
    ];

export default data;
